"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlantManagerModule = /** @class */ (function () {
    function PlantManagerModule() {
    }
    return PlantManagerModule;
}());
exports.PlantManagerModule = PlantManagerModule;
